module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-superiority.06df19d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-superiority.jpg
// module id = 2822
// module chunks = 11